import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { SteeringWheel } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";

const IMG = "https://images.pexels.com/photos/18048834/pexels-photo-18048834.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const field = "w-full bg-secondary border border-border rounded-sm px-4 py-3 text-sm focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary transition-colors placeholder:text-muted-foreground";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await register(form);
    setLoading(false);
    if (res.error) return toast.error(res.error);
    toast.success("Account created!");
    navigate("/dashboard");
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="flex items-center justify-center px-6 py-24 order-2 lg:order-1">
        <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="w-full max-w-sm">
          <Link to="/" className="flex items-center gap-2 mb-10">
            <SteeringWheel size={26} weight="fill" className="text-primary" />
            <span className="font-display font-black tracking-tighter uppercase text-sm">Ranchi·Digital Seva</span>
          </Link>
          <h1 className="font-display font-black uppercase tracking-tighter text-4xl">Create account</h1>
          <p className="text-muted-foreground text-sm mt-2 mb-8">Start your license application in minutes.</p>
          <form onSubmit={submit} className="space-y-4" data-testid="register-form">
            <input required data-testid="register-name" className={field} placeholder="Full name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
            <input required type="email" data-testid="register-email" className={field} placeholder="Email address" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
            <input data-testid="register-phone" className={field} placeholder="Phone number" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
            <input required type="password" minLength={6} data-testid="register-password" className={field} placeholder="Password (min 6 chars)" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
            <button type="submit" disabled={loading} data-testid="register-submit" className="w-full py-4 bg-primary text-primary-foreground font-mono text-sm uppercase tracking-widest font-medium rounded-sm hover:bg-primary/90 transition-colors disabled:opacity-60">
              {loading ? "Creating…" : "Create account"}
            </button>
          </form>
          <p className="text-sm text-muted-foreground mt-6">
            Already registered? <Link to="/login" data-testid="link-login" className="text-primary hover:underline">Log in</Link>
          </p>
        </motion.div>
      </div>
      <div className="hidden lg:block relative order-1 lg:order-2">
        <img src={IMG} alt="Highway" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/60" />
        <div className="absolute bottom-12 right-12 max-w-sm text-right">
          <h2 className="font-display font-black uppercase tracking-tighter text-4xl leading-none">The road is<br />waiting.</h2>
        </div>
      </div>
    </div>
  );
}
